import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { GlobalState } from "./types";

const initialState: GlobalState = {
  dialogId: null,
  payload: {},
  isOnline: true,
};

export const globalSlice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    setDialogId: (
      state: GlobalState,
      action: PayloadAction<{
        id: string | null;
        payload?: Record<string, unknown>;
      }>,
    ) => {
      const { id, payload } = action.payload;
      state.dialogId = id;
      if (!id) state.payload = {};
      else if (payload) state.payload = payload;
    },
    setIsOnline: (state: GlobalState, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
    resetGlobalState: () => initialState,
  },
});

export const { setDialogId, resetGlobalState, setIsOnline } =
  globalSlice.actions;
